var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.50171H16.25",
    stroke: "#A5A5A5",
    strokeWidth: 1.51144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8609 5.50171V16.0003C14.8609 16.7502 14.1665 17.5001 13.472 17.5001H6.52756C5.83312 17.5001 5.13867 16.7502 5.13867 16.0003V5.50171",
    stroke: "#A5A5A5",
    strokeWidth: 1.51144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22168 5.4996V3.9998C7.22168 3.2499 7.91612 2.5 8.61057 2.5H11.3883C12.0828 2.5 12.7772 3.2499 12.7772 3.9998V5.4996",
    stroke: "#A5A5A5",
    strokeWidth: 1.51144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61206 9.24927V13.7487",
    stroke: "#A5A5A5",
    strokeWidth: 1.51144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3887 9.24927V13.7487",
    stroke: "#A5A5A5",
    strokeWidth: 1.51144,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash2);
export default __webpack_public_path__ + "static/media/ic_trash-2.28c44a7c28f830bb556eb5125cf9e332.svg";
export { ForwardRef as ReactComponent };